var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInputMap = function SvgInputMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "inputMap_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#inputMap_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8C9194",
    d: "M12 16.83q2.657-2.122 4.014-4.078t1.358-3.724q0-1.507-.55-2.56t-1.36-1.71a5.3 5.3 0 0 0-1.746-.955q-.938-.297-1.716-.297-.777 0-1.716.297a5.3 5.3 0 0 0-1.747.954q-.81.659-1.359 1.711-.55 1.053-.55 2.56 0 1.768 1.357 3.723Q9.343 14.709 12 16.83m0 1.284a1.16 1.16 0 0 1-.727-.26q-1.968-1.54-3.934-3.821Q5.37 11.75 5.372 9.028q0-1.676.6-2.939t1.55-2.12A6.5 6.5 0 0 1 9.66 2.68q1.185-.43 2.34-.43t2.341.43 2.137 1.289a6.7 6.7 0 0 1 1.551 2.12q.6 1.263.6 2.94 0 2.722-1.967 5.004-1.967 2.28-3.934 3.82a1.156 1.156 0 0 1-.727.26m.002-7.608q.68 0 1.153-.475t.473-1.155-.475-1.153a1.58 1.58 0 0 0-1.155-.473q-.68 0-1.153.475a1.58 1.58 0 0 0-.473 1.155q0 .68.475 1.153.475.474 1.155.473M6 21.75a.6.6 0 0 1-.448-.182.61.61 0 0 1-.18-.45q0-.267.18-.446A.61.61 0 0 1 6 20.494h12q.267 0 .447.181t.18.45q0 .27-.18.447a.61.61 0 0 1-.447.178z"
  }))));
};
export default SvgInputMap;